/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProposedCriterionDeltaOperation = typeof ProposedCriterionDeltaOperation[keyof typeof ProposedCriterionDeltaOperation];


export const ProposedCriterionDeltaOperation = {
  add: 'add',
  update: 'update',
  remove: 'remove',
} as const;
